import { createContext, useContext } from 'react';

/* Les infobulles sont actives par défaut ; un panneau qui n'en veut pas (le
   panneau de droite, cf. RightSide.jsx et BoxFormControlsPortal) les coupe pour
   tout ce qu'il contient, et un contrôle précis les rallume (cf. KeepTooltip).
   Les composants qui créent une infobulle (common/Tooltip, NavbarButton...) ne la
   montent alors tout simplement pas. Un contexte React suit l'arbre React, pas
   le DOM : un contrôle rendu dans un portail voit celui de l'endroit où il est
   monté, d'où le fournisseur posé dans BoxFormControlsPortal. */
export const TooltipsContext = createContext(true);

export const useTooltipsEnabled = () => useContext(TooltipsContext);
